import { render, staticRenderFns } from "./FormRestricao.vue?vue&type=template&id=0b84d358"
import script from "./FormRestricao.vue?vue&type=script&lang=js"
export * from "./FormRestricao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports